import { CreditCard } from "lucide-react";
import { PURCHASE_POINTS_NOT_ONBOARDED_MESSAGE } from "@/features/purchasePoints/config/purchasePoints.config";

export const PurchasePointsEarningInvitation = () => (
  <p className="mt-4 inline-flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
    <CreditCard size={20} aria-hidden="true" className="shrink-0" />
    {PURCHASE_POINTS_NOT_ONBOARDED_MESSAGE}
  </p>
);

PurchasePointsEarningInvitation.displayName = "PurchasePointsEarningInvitation";
